import React, { useState } from 'react';
import { Button, Checkbox, Modal } from '../../../components';
import Icon from '../../../components/icon/icon';
import PropTypes from 'prop-types';
import { X } from '@phosphor-icons/react';
import './style';

const CheckModal = (props) => {
  const { 
    isOpen,
    onClose,
    header,
    infocard,
    checkContent,
    onCtaClick,
    ctaContent,
  } = props;
  const [checkState, setCheckState] = useState(false);

  const handleCheckboxChange = (id, event) => {
    setCheckState(event?.target?.checked);
  };

  const handleCheckboxClick = () => {
    setCheckState(prevState => !prevState);
  };

  return (
    <div>
      <Modal 
        isOpen={isOpen}
        onClose={onClose}
        className='check-modal'
      >
        <div className='flex flex-col gap-6'>
          <div className='flex w-full justify-between'> 
            <div className='heading-16 md:heading-24'>{header}</div>
            <Icon onClick={onClose}
              className='cursor-pointer'>
              <X size={24} />
            </Icon>
          </div>
          <div className='py-4 px-3 rounded-xl flex gap-2 bg-light'>
            {infocard}
          </div>
          <div onClick={handleCheckboxClick} 
            className='flex items-start gap-2 cursor-pointer checkbox1'>
            <Checkbox
              id='checkbox1'
              checked={checkState}
              onChange={handleCheckboxChange}
              className='mt-1 '
            />
            <label htmlFor='checkbox1' 
              className='cursor-pointer'>
              {checkContent}
            </label>
          </div>
          <Button 
            type='primary'
            onClick={onCtaClick}
            disabled={!checkState}
            className='w-full'
          >
            {ctaContent}
          </Button>
        </div>
      </Modal>
    </div>
  );
}

CheckModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  header: PropTypes.node,
  infocard: PropTypes.node,
  checkContent: PropTypes.node,
  onCtaClick: PropTypes.func,
  ctaContent: PropTypes.node,
};

CheckModal.defaultProps = {
  header: '',
  infocard: '',
  checkContent: '',
  onCtaClick: () => console.log('CTA button clicked'),
  ctaContent: 'Next',
};

export default CheckModal;
